import { render, staticRenderFns } from "./qrfloat.vue?vue&type=template&id=57d2504e&scoped=true"
import script from "./qrfloat.vue?vue&type=script&lang=js"
export * from "./qrfloat.vue?vue&type=script&lang=js"
import style0 from "./qrfloat.vue?vue&type=style&index=0&id=57d2504e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57d2504e",
  null
  
)

export default component.exports